export const BILLLIN_GO_PATH = "/go/billlin";

export function billlinGoHref(query?: string): string {
  if (!query?.trim()) return BILLLIN_GO_PATH;
  const q = query.startsWith("?") ? query.slice(1) : query;
  return `${BILLLIN_GO_PATH}?${q}`;
}
